import './ProductSwitch.css'

/**
 * Which product a Marketing screen is talking about.
 *
 * Newsletter and Email automation used to be sub-tabs of Skida PRO and Skida
 * App, so the product was implied by where you were standing. The 12 Aug
 * prototype moved both under Marketing, which means the product has to be
 * chosen on the screen instead — `marketingNewsletterProduct` in the design.
 *
 * Two filter chips labelled with the domains, not the product names. The design
 * writes them as `skida.app` and `skida.pro`, and it is right to: this control
 * decides which of two sending identities a campaign goes out as, and
 * `post@news.skida.app` is a more honest label for that than "App".
 */

export type Product = 'app' | 'pro'

export function ProductSwitch({
  value,
  onChange,
}: {
  value: Product
  onChange: (p: Product) => void
}) {
  return (
    <div className="prodswitch" role="group" aria-label="Product">
      {(['app', 'pro'] as Product[]).map((p) => (
        <button
          key={p}
          type="button"
          className="chip"
          aria-pressed={value === p}
          onClick={() => onChange(p)}
        >
          {p === 'app' ? 'skida.app' : 'skida.pro'}
        </button>
      ))}
    </div>
  )
}
